export default __webpack_public_path__ + "8352052193821a253224677445090246.png";